import styles from './Connected.module.css';

export function LoadingScreen({status}: {status: string}) {
  return (
    <div className={styles.centerConnecting}>
      {status}
    </div>
  );
}
